import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { useState } from "react";
import { requestDeleteStudentPenalty, requestUpdateStudentPenalty } from "services/settings/penaltyAdmin/dataAboutPenaltyAdmin";
import useMainContext from "utils/context/useMainContext";

const useHandlerActions = ({
    loadingRequest, 
    fillStudentPenaltyList
}) => {
    //#region States
    const [currentStudentPenaltyForDoAction, setCurrentStudentPenaltyForDoAction] = useState(null);
    //#endregion
    //#region Custom Hooks
    const mainContext = useMainContext();
    const dialogDeletePenaltyStudent = useShowDialogAlert();
    const dialogUpdatePenaltyStudent = useShowDialogAlert();
    //#endregion
    //#region Functions
    const openUpdatePenaltyStudentDialog = item => {
        setCurrentStudentPenaltyForDoAction(item);
        dialogUpdatePenaltyStudent.open();
    }
    const openDeletePenaltyStudentDialog = item => {
        setCurrentStudentPenaltyForDoAction(item);
        dialogDeletePenaltyStudent.open();
    }
    const deleteAction = async () => {
        dialogDeletePenaltyStudent.hide();
        loadingRequest.show("Eliminando sanción...");
        const success = await requestDeleteStudentPenalty(currentStudentPenaltyForDoAction.id);
        loadingRequest.hide();
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        fillStudentPenaltyList({ 
            toastMessage: "¡Se eliminó exitosamente la sanción del alumno(a)!" 
        });
    }
    const updateAction = async form => {
        dialogUpdatePenaltyStudent.hide();
        loadingRequest.show("Editando sanción...");
        const success = await requestUpdateStudentPenalty(form);
        loadingRequest.hide();
        // Fallido
        if (!success) {
            mainContext.setShowDialogUnexpectedError(true);
            return;
        }
        // Exitoso
        fillStudentPenaltyList({
            penaltyId: form.id,
            messageForToast: "¡Se editó exitosamente la sanción del alumno(a)!" 
        });
    }
    //#endregion
    return {
        currentPenaltyStudentForDoAction: {
            value: currentStudentPenaltyForDoAction,
            set: setCurrentStudentPenaltyForDoAction
        },
        dialogs: {
            dialogDeletePenaltyStudent,
            dialogUpdatePenaltyStudent
        },
        actions: {
            apply: {
                deleteAction,
                updateAction,
            },
            openDialog: {
                openUpdatePenaltyStudentDialog,
                openDeletePenaltyStudentDialog
            }
        }
    };
}

export default useHandlerActions;